import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { SGA_LOGIN_ACTION_TYPE } from "./sga-login.action";
import { SgaLoginState } from "./sga-login.model";

const INITIAL_STATE: SgaLoginState = {
	selectedLoginTab: undefined,
};

export function sgaLoginReducer(state = INITIAL_STATE, action: ActionWithPayload): SgaLoginState {
	switch (action.type) {
		case SGA_LOGIN_ACTION_TYPE.selectLoginTab: {
			return updateState(state, {
				selectedLoginTab: action.payload,
			});
		}
		default: {
			return state;
		}
	}
}
